import { ReportValidationStatusComponent } from './report-validation-status.component';

export default angular
  .module('sfMobile.components.report-validation-status', [])
  .component('sfReportValidationStatus', ReportValidationStatusComponent).name;
